import { Button, Center, Image, Stack, Text } from '@mantine/core';
import Card from 'components/Card';
import React from 'react';
import { HiOutlineHome } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

interface IBrokenApprovalCourseLink {
  type?: 'approval' | 'submit-material';
}

const BrokenApprovalCourseLink: React.FC<IBrokenApprovalCourseLink> = ({ type = 'approval' }) => {
  const navigate = useNavigate();
  const description = type === 'submit-material' ? 'submit course material' : 'approval course';
  return (
    <Card py={72}>
      <Center>
        <Stack>
          <Center>
            <Image
              src={'/images/illustration-broken-link.svg'}
              alt='Link has been expired or no longer valid'
              w={345}
              h={300}
            />
          </Center>
          <Stack gap={8} maw={500}>
            <Text ta={'center'} fw={700} c={'dark'} fz={36}>
              Link Has Expired
            </Text>
            <Text ta={'center'} fz={16}>
              This {description} form link has expired or is no longer valid. Please contact the
              program administrator or email{' '}
              <Text component='a' fw={700} href='mailto:bcld.support@binus.ac.id'>
                bcld.support@binus.ac.id
              </Text>{' '}
              to request a new link.
            </Text>
          </Stack>

          <Center>
            <Button
              leftSection={<HiOutlineHome />}
              onClick={() => navigate('/', { replace: true })}
            >
              Return Home
            </Button>
          </Center>
        </Stack>
      </Center>
    </Card>
  );
};

export default BrokenApprovalCourseLink;
